<template>
<div class="item">
    <!-- <v-layout column>
        
        <v-row>
          <v-flex  md6 lg6 > -->
          <div class='item-label' v-resize-text="{ratio: 1.3,minFontSize:'6px',maxFontSize:'18px' }">{{label}}</div>
          <!--</v-flex>
          </v-row>
          
        <v-row  red md12 lg12>
          <v-flex md12 lg12  > -->
            <div class='item-value' v-resize-text="{ratio:.9,minFontSize:'8px',maxFontSize:'28px'}" style="fontWeight: bold;">{{value}}</div>
            <!-- </v-flex>
          </v-row>
          <v-row />
        
    </v-layout> -->
    </div>
</template>

<script>
export default {
    props: ['label', 'value']
}
</script>

<style scoped>
.item {
  display: block;
  grid-template-columns: 1fr ;
  grid-gap: 2px;
  /* grid-template-rows: repeat(2, 1fr); */
  margin: 1em;
  height: 100% !important;
  padding: 0px !important;
}
.item-label {
  background-color: antiquewhite;
    /* font-size: 1em; */
    color: blue;
    /* height: 100%; */
}
.item-value {
  background-color: lightblue;
  /* height: 100%; */
    /* font-size: 2rem; */
    color: red;
}
</style>
